var _rect, _ellipse, _path, _path2, _path3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDisabledVideo = function SvgDisabledVideo(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.619141,
    y: 4.7,
    width: 28.7609,
    height: 21.7304,
    rx: 3.14239,
    fill: "#DFDFDF"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.3196,
    cy: 15.5652,
    rx: 4.47391,
    ry: 4.47391,
    fill: "#C4C4C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.876 15.5653L14.0412 17.7793L14.0412 13.3513L17.876 15.5653Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5573 4.7C28.2928 4.7 29.6997 6.10689 29.6997 7.84239L29.6997 23.288C29.6997 25.0235 28.2928 26.4304 26.5573 26.4304L24.9062 26.4304L24.9062 4.7L26.5573 4.7Z",
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09326 4.7L5.09326 26.4304L3.44217 26.4304C1.70668 26.4304 0.299782 25.0235 0.299782 23.288L0.299783 7.84239C0.299783 6.1069 1.70668 4.7 3.44217 4.7L5.09326 4.7Z",
    fill: "#C4C4C4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.57812,
    y: 8.53481,
    width: 2.23696,
    height: 3.19565,
    rx: 0.628478,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1846,
    y: 8.53481,
    width: 2.23696,
    height: 3.19565,
    rx: 0.628478,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 1.57812,
    y: 14.287,
    width: 2.23696,
    height: 3.19565,
    rx: 0.628478,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1846,
    y: 14.287,
    width: 2.23696,
    height: 3.19565,
    rx: 0.628478,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1.57812,
    y: 20.0391,
    width: 2.23696,
    height: 3.19565,
    rx: 0.628478,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 26.1846,
    y: 20.0391,
    width: 2.23696,
    height: 3.19565,
    rx: 0.628478,
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDisabledVideo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/disabled-video.18ce3194abc483656656d0959908ce95.blank.svg";